import BitflowImage from 'images/bitflow.svg';
import BridgeImage from 'images/bridgestacks.png';
// import СharismaImage from 'images/charisma.png';
import EcoImage from 'images/eco.svg';
import GraniteImage from 'images/granite_logo.png';
import HermeticaImage from 'images/hermetica.svg';
import StackingDaoImage from 'images/stackingDao.png';
import StxCityImage from 'images/stxcity.png';
import VelarImage from 'images/velar.png';
import ZestImage from 'images/zest.png';

export const APP_CATEGORIES = [
  'Bridge',
  'DEX',
  'Utility',
  'Launchpad',
  'Liquid Stacking',
  'DeFi',
  'Lending',
  'Memecoins',
] as const;

export type AppCategory = (typeof APP_CATEGORIES)[number];

export type AppsMetadata = {
  title?: string;
  description?: string;
  favicon?: string;
  url?: string;
};

export type Application = {
  caption: string;
  url: string;
  testnetUrl?: string;
  logo: string;
  category: AppCategory[];
  description: string;
  isExternal?: boolean;
};

export const APP_LIST: Application[] = [
  {
    caption: 'Pontis',
    url: 'https://app.pontis.io/',
    logo: 'https://pontis.io/web-app-manifest-192x192.png',
    category: ['Bridge'],
    description:
      'Pontis is an innovative bridge designed to seamlessly connect the Bitcoin ecosystem.',
  },
  {
    caption: 'Bitflow',
    url: 'https://app.bitflow.finance/trade',
    logo: BitflowImage,
    category: ['DEX'],
    description:
      'Bitflow is the best place to trade and earn with BTC assets across high-traffic pools. With its powerful DEX aggregator guaranteeing the best swap rates, Runes AMM, Native BTC Swaps, and deep liquidity pools, Bitflow is advancing the future of Bitcoin-native assets and DeFi, built for smart traders who want the highest returns.',
  },
  {
    caption: 'USDCx Bridge',
    url: 'https://bridge.stacks.co/',
    description: 'Bridge your USDC to Stacks in 5 simple steps, secured by Circle.',
    logo: BridgeImage,
    category: ['Bridge'],
    isExternal: true,
  },
  {
    caption: 'Velar',
    url: 'https://app.velar.com/swap',
    description:
      'Velar is a DeFi liquidity protocol on Bitcoin via Stacks, which brings a host of DeFi-native features, from token swaps to launchpad infrastructure.',
    logo: VelarImage,
    category: ['Utility', 'Launchpad'],
    isExternal: true,
  },
  {
    caption: 'Zest',
    url: 'https://app.zestprotocol.com/',
    logo: ZestImage,
    category: ['Lending'],
    description:
      'Zest Protocol is an on-chain lending protocol, built for Bitcoin. It strives to create a vibrant borrowing and lending ecosystem around BTC the asset.',
  },
  {
    caption: 'StackingDAO',
    url: 'https://app.stackingdao.com/',
    logo: StackingDaoImage,
    category: ['Liquid Stacking'],
    description:
      'A liquid stacking protocol that gives users an auto compounding tokenised representation of stacked STX (stSTX).',
  },
  {
    caption: 'Alex',
    url: 'https://app.alexlab.co/',
    isExternal: true,
    logo: 'https://avatars.githubusercontent.com/u/85433080?s=200&v=4',
    category: ['DeFi'],
    description:
      'Next Gen DeFi on Bitcoin via Stacks. Focus on trading, lending and borrowing of crypto assets with Bitcoin as the settlement layer and Stacks as the smart contract layer.',
  },
  {
    caption: 'Arkadiko',
    url: 'https://app.arkadiko.finance/',
    logo: 'https://assets-global.website-files.com/618b0aafa4afde9048fe3926/61935d03c4bb83f38a6f9d91_arkadiko_icon.jpg',
    category: ['DeFi'],
    isExternal: true,
    description:
      'Arkadiko is an open source and non-custodial liquidity protocol for minting stablecoins, earning interest on deposits and borrowing assets on Stacks.',
  },
  {
    caption: 'Hermetica',
    url: 'https://app.hermetica.fi/stake',
    logo: HermeticaImage,
    category: ['DeFi'],
    description: 'A Bitcoin-backed, yield-bearing synthetic dollar protocol.',
  },
  {
    caption: 'Brotocol',
    url: 'https://brotocol.xyz/',
    isExternal: true,
    logo: 'https://cdn.prod.website-files.com/67fa933a1009eed541d4da84/67fb95020b5d451d70737c4b_Brotocol_logo_mini.svg',
    category: ['DeFi', 'Bridge'],
    description:
      'Brotocol brings DeFi functionality to Bitcoin rather than moving Bitcoin elsewhere, allowing you to keep your BTC on Bitcoin.',
  },
  {
    caption: 'STX ECO',
    url: 'https://stx.eco/',
    description:
      'STX ECO is the all-in-one voting platform where the Stacks community can weigh in on major protocol changes.',
    logo: EcoImage,
    category: ['Utility'],
  },
  {
    caption: 'Granite',
    url: 'https://app.granite.world/',
    description:
      'Decentralized platform that lets Bitcoin holders borrow stablecoins without custody risk and earn yield on liquidity.',
    logo: GraniteImage,
    category: ['DeFi', 'Liquid Stacking'],
  },
  {
    caption: 'stx.city',
    url: 'https://stx.city',
    logo: StxCityImage,
    category: ['Memecoins'],
    description:
      'Launch your memecoin and distribute airdrops to thousands of addresses in minutes.',
  },
  // {
  //   caption: 'Charisma',
  //   url: 'https://charisma.rocks/swap',
  //   description: 'Stake your memecoins and earn rewards on Stacks.',
  //   logo: СharismaImage,
  //   category: ['Utility'],
  //   isExternal: true,
  // },
];
